<ag-grid-angular *ngIf="gridReady" style="width: 100%; height: 100%;" [columnDefs]="columnDefs"
    [detailCellRenderer]="detailCellRenderer" [detailCellRendererParams]="detailCellRendererParams" [detailRowHeight]="400" [masterDetail]="true"
    [defaultColDef]="defaultColDef" [autoGroupColumnDef]="autoGroupColumnDef"
    [rowGroupPanelShow]="rowGroupPanelShow" [rowData]="positions" [class]="themeClass" (gridReady)="onGridReady($event)">
</ag-grid-angular>